import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {  Link } from 'react-router-dom';

function Select() {

    const [show, setShow] = useState(false);


    const [func, setFunc] = useState([]);
    const [select, setSelect] = useState([]);

    const [formData, setFormData] = useState([]);

    useEffect(() => {
        getSelect();
        FuncData();
    }, []);

    const handleInputChange = (event) => {
        setFormData(event.target.value)
        console.log(event.target.value);
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

        const handleSubmit = (event) => {
        event.preventDefault();
        if (true) {
            // Do something with the form data
            fetch('/admin/index/AddRoleSelect/' + formData)
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        handleClose();
                        FuncData();
                    } else {
                        handleClose();
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        } else {
            console.log("tete");
        }
    }
    async function getSelect() {

        const response = await fetch('admin/index/getselect');
        const data = await response.json();
        setSelect(data);
    }
    async function FuncData() {
        const response = await fetch('admin/index/getRoleSelect');
        const data = await response.json();
        setFunc(data.list);
    }

    const DeleteRoleSelect = (event,id) => {
        event.preventDefault();

            // Do something with the form data
            fetch('/admin/index/DeleteRoleSelect/' + id)
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        FuncData();
                    } else {

                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
    }
    return (
        <div className="widget-group bot">
            <div className="widget-box">
                <div className="widget-box-header" style={{ backgroundColor: '#32b6df' }}>個人化作業快捷選單
                </div>
                <div className="widget-box-content">
                    <div className="group-cont">
                        <ul className="modal_list">
                            <li><a className="bookmark-link" onClick={handleShow} ><img src="assets/images/bookmark-add-guild.png" alt="" /> </a></li>
                       
                        <Modal show={show} onHide={handleClose}
                            dialogClassName="widget_box_modal"
                            centered>
                            <Modal.Header className="modal_header" closeButton>
                                <Modal.Title >個人化作業快捷選單</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <select className="modal_select" size="8" value={formData.roleDept} onChange={handleInputChange}>
                                    {select.map((selects, index) =>
                                        <option key={index} value={selects.funcId} >{selects.funcName}</option>
                                    )}
                                </select>
                            </Modal.Body>
                            <Modal.Footer className="d-flex justify-content-center">
                                <Button variant="primary" onClick={handleSubmit}>
                                    新增
                                </Button>
                            </Modal.Footer>
                        </Modal>
                            {func.map((funcs, index) =>
                                <li key={index} ><a className="close" onClick={(event) => DeleteRoleSelect(event, funcs.selectId) }  >x</a><Link to={funcs.funcIntraUrl}><div ><img src="intranet/assets/images/bookmark-link1.png" alt="" /></div><div className="info">{funcs.funcName}</div></Link></li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )

} export default Select;